import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

const OverlayLoader = ({ open = false, message = "Processing..." }) => {
  const { dark, primary, light } = colors;
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 20,
        backdropFilter: "blur(4px)",
        backgroundColor: rgba(light.secondary, 0.3),
      }}
    >
      <VuiBox display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <CircularProgress
          size={42}
          thickness={4}
          color="primary"
          sx={{
            mb: 2,
          }}
        />

        <VuiTypography variant="button" fontWeight="medium">
          {message}
        </VuiTypography>
      </VuiBox>
    </Backdrop>
  );
};

export default OverlayLoader;
